import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { format } from 'date-fns';

@Directive({
  selector: '[utilFormatDate]',
  standalone: true,
})
export class FormatDateDirective implements OnChanges {
  @Input() rawDate!: undefined | null | string | Date;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rawDate'] && this.rawDate) {
      const formatted = this.formatDate(this.rawDate);
      this.renderer.setProperty(this.el.nativeElement, 'innerText', formatted);
    } else {
      this.renderer.setProperty(this.el.nativeElement, 'innerText', '');
      return;
    }
  }
  private formatDate(date: string | Date): string {
    try {
      const d = new Date(date);
      return format(d, 'HH:mm MM/dd/yyyy');
    } catch (err) {
      return '';
    }
  }
}
